import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    blockThisDevice: 'Block this device',
    blockThisDeviceSubtitle:
      'Your account may be at risk if you did not attempt to login.',
    blockThisDeviceTitle: 'Do you want to block this device?',
    cancel: 'Cancel',
    device: 'Device',
    lastConnection: 'Last connection',
    location: 'Location',
    unknownDeviceType: 'Unknown device type',
  },
  fr: {
    blockThisDevice: 'Bloquer cet appareil',
    blockThisDeviceSubtitle:
      'Votre compte peut être en danger si vous n’êtes pas à l’initiative de cette connexion.',
    blockThisDeviceTitle: 'Voulez-vous bloquer cet appareil ?',
    cancel: 'Annuler',
    device: 'Appareil',
    lastConnection: 'Dernière connexion',
    location: 'Lieu',
    unknownDeviceType: 'Type d’appareil inconnu',
  },
});

export default locales;
